/**
 * Single source of truth for the app's display name, so it can be rebranded via
 * env without touching code. Set REACT_APP_APP_NAME in .env.
 */
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Apiboo';

/** URL/topic-safe slug of the app name (lowercase, hyphenated). */
export const APP_SLUG =
  APP_NAME.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'apiboo';

/** GitHub topic used to flag repositories that hold an app workspace. */
export const WORKSPACE_TOPIC = `${APP_SLUG}-workspace`;
